import React from 'react';
import { Container } from 'react-bootstrap';
import ScheduleForm from '../components/scheduling/ScheduleForm';

const ScheduleJob = () => {
  return (
    <Container fluid className="schedule-job-page-container">
      <ScheduleForm />
    </Container>
  );
};

export default ScheduleJob;
